/**
 * Shared sidebar UI: minimal, professional, consistent.
 * Uses theme palette (background, card, muted, accent, primary, border, foreground).
 */

export const sidebar = {
  root: 'shrink-0 h-full w-[272px] flex flex-col overflow-hidden border-r border-sidebar-border bg-sidebar text-sidebar-foreground shadow-[10px_0_32px_rgba(0,0,0,0.22)] backdrop-blur-sm supports-backdrop-filter:bg-sidebar/96',
  header: 'sticky top-0 z-10 flex shrink-0 items-center justify-between gap-2 border-b border-sidebar-border bg-sidebar px-3 py-3 backdrop-blur-sm',
  title: 'truncate text-[11px] font-medium uppercase tracking-[0.16em] text-sidebar-foreground',
  closeButton:
    'flex h-7 w-7 items-center justify-center rounded-md text-sidebar-foreground/60 transition-colors hover:bg-sidebar-accent/60 hover:text-sidebar-foreground focus:outline-hidden focus-visible:ring-2 focus-visible:ring-ring/50 focus-visible:ring-offset-1 focus-visible:ring-offset-sidebar',
  body: 'flex-1 overflow-y-auto min-h-0 overscroll-contain',
  bodyPad: 'px-2.5 py-2',
  sectionLabel: 'mb-1.5 text-[9px] font-medium uppercase tracking-[0.14em] text-sidebar-foreground/50',
  primaryButton:
    'w-full flex items-center justify-center gap-2 rounded-xl border border-primary/30 bg-primary/15 px-3 py-2.5 text-[12px] font-medium text-primary transition-colors hover:bg-primary/20 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-ring/50 focus-visible:ring-offset-1 focus-visible:ring-offset-sidebar',
  card: 'rounded-xl border border-sidebar-border bg-sidebar',
  rowButton:
    'w-full flex items-center justify-between rounded-lg px-2.5 py-1.5 text-left text-[12px] text-sidebar-foreground/70 transition-colors hover:bg-sidebar-accent/60 hover:text-sidebar-foreground',
  rowLink: 'text-primary font-medium text-[12px]',
  doneButton:
    'w-full rounded-lg border border-sidebar-border bg-sidebar-accent px-2.5 py-2 text-[12px] font-medium text-sidebar-foreground transition-colors hover:bg-sidebar-accent/70',
  pillSolidSelected: 'border border-primary/30 bg-primary/15 text-primary',
  pillDefault:
    'border border-sidebar-border bg-sidebar text-[11px] text-sidebar-foreground/70 hover:bg-sidebar-accent/60 hover:text-sidebar-foreground',
  toggleOn: 'bg-primary',
  toggleOff: 'bg-track-off',
  selectionBar: 'bg-primary/80',
} as const;
